import { BaseAsyncValue } from '@ordersnproducts/modules/shared/models/async-value';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { filter } from 'rxjs/operators';
import { getOneClickOwnFreightPlantSelected } from '@ordersnproducts/modules/one-click-order/selectors/one-click-ownFreight-plants.selector';

export class OneClickOwnFreightPlantProvider extends BaseAsyncValue<string> {
  getValue(): Observable<string> {
    return this.store.select(getOneClickOwnFreightPlantSelected).pipe(
      filter(plant => !!plant),
      map(plant => {
        return `${plant.plantDesc}`;
      }),
    );
  }
}
